// ─── Feuille : CHOIX des calendriers IVV visibles ─────────────────
// Même schéma que « Fonctions & activation » : la bascule active la fonction,
// une LIGNE ouvre l'écran de sélection. La page Profil reste courte.
import React from 'react';
import Feuille from '../ui/Feuille';
import { useT } from '../i18n/LangueContext';
import ListeCalIvv from './ListeCalIvv';

export default function FeuilleCalIvv({ visible, user, onFermer }) {
  const t = useT();
  return (
    <Feuille visible={visible} titre={t('profil.calIvvVisibles')} emoji="🐞" hauteur={0.7} onFermer={onFermer}>
      <ListeCalIvv user={user} />
    </Feuille>
  );
}
